// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import { useParties } from '../contexts/PartiesContext';

interface ActionNeededIndicatorProps {
  receiver: string;
  isOffered: boolean;
}
export const ActionNeededIndicator: React.FC<ActionNeededIndicatorProps> = ({
  isOffered,
  receiver,
}) => {
  const { party } = useParties();

  return (
    <CircleIcon
      sx={{
        color: '#577FF1',
        visibility: isOffered && party === receiver ? 'visible' : 'hidden',
        mr: 0,
        display: 'flex',
        scale: 0.5,
      }}
      fontSize="small"
    />
  );
};
